// Admin Page Slice
import { adminPageInitialState } from "./uiAdminPageState";
import { makeAdminPageActions } from "./uiAdminPageActions";

export const createAdminPageSlice = (set, get) => ({
  adminPage: adminPageInitialState,
  adminPageActions: makeAdminPageActions(set, get),
});
